export enum Tab {
  WorkspaceSettings = 'workspace-settings',
  Events = 'events',
  Users = 'users',
  Recordings = 'recordings',
  Analytics = 'analytics',
  Emojis = 'emojis',
}

export enum BuilderTab {
  Details = 'details',
}

export enum WorkspaceSettingsTab {
  OrganizationSettings = 'settings',
  Team = 'team',
}
